import { isDebug } from '../hn-debug';
export const getResourceWithId = (json) => {
    return Object.keys(json).reduce((previous, key) => {
        if (typeof json[key] === 'string') {
            previous[key] = json[key] + ' [' + key + ']';
        }
        else if (json[key]?.type === 'markdown') {
            previous[key] = json[key].value + ' [' + key + ']';
        }
        return previous;
    }, {});
};
export const getResourceWithIdOnly = (json) => {
    return Object.keys(json).reduce((previous, key) => {
        if (typeof json[key] === 'string') {
            previous[key] = `[${key}]`;
        }
        else if (json[key]?.type === 'markdown') {
            previous[key] = `[${key}]`;
        }
        return previous;
    }, {});
};
export function getModifiedResourcesForTest(resourceText) {
    if (!resourceText) {
        return undefined;
    }
    if (isDebug() && window.document.URL.includes('ressurstekstid=true')) {
        return getResourceWithIdOnly(resourceText);
    }
    // hjelpetekst=true støttes av historiske årsaker, selv om begrepet egentlig brukes om prosesshjelpen og ikke ressurstekster fra SOT
    if (isDebug() && (window.document.URL.includes('ressurstekst=true') || window.document.URL.includes('hjelpetekst=true'))) {
        return getResourceWithId(resourceText);
    }
    if (process.env.NODE_ENV === 'test') {
        return Object.keys(resourceText).reduce((previous, key) => {
            previous[key] = key;
            return previous;
        }, {});
    }
    return resourceText;
}
